import gql from 'graphql-tag'

const tagVars = `id label type order info`
export const tagDetailVars = `${tagVars} meta info group { id label info }`

export const LIST_TAGS = gql`
  query tags($type: TagType!, $matching: String) {
    tags(type: $type, matching: $matching) {${tagVars}}
  }
`

export const LIST_TAGS_DETAILED = gql`
  query listTagsDetailed($type: TagType!, $matching: String) {
    tags(type: $type, matching: $matching) {${tagDetailVars}}
  }
`

export const TAGS_CHANGE_MINE = gql`
  mutation tagChangeMine(
    $id: UUID!
    $type: TagType!
    $public: Boolean
    $rate: Float
  ) {
    tagChangeMine(id: $id, type: $type, public: $public, rate: $rate) {
      success
      reason
      user {
        id
        tags {
          id
          type
          public
          tag {${tagVars}}
        }
      }
    }
  }
`

export const TAGS_CHANGE_USER = gql`
  mutation tagsChangeUser($tags: InputTagsChange!) {
    tagsChange(tags: $tags) {
      success
      reason
      user {
        id
        tags {
          id
          type
          public
          tag {${tagVars}}
        }
      }
    }
  }
`

export const TAGS_CHANGE_PROJECT = gql`
  mutation tagsChangeProject($tags: InputTagsChange!) {
    tagsChange(tags: $tags) {
      success
      reason
      project {
        id
        tags {
          id
          tag {${tagVars}}
        }
      }
    }
  }
`

export const TAGS_CHANGE_ORG = gql`
  mutation tagsChangeOrg($tags: InputTagsChange!) {
    tagsChange(tags: $tags) {
      success
      reason
      org {
        id
        tags {
          id
          tag {
            id
            label
            type
            meta
          }
        }
      }
    }
  }
`
